<div id="app">

    <app-sidebar [ngStyle]="!isVisible && {'visibility': 'collapse', 'width': '0'} || null"></app-sidebar>
    <div id="layout" [ngClass]="isSidebarCollapsed ? 'collapsed-sidebar' : 'expanded-sidebar'" [ngStyle]="!isVisible && {'margin-left': '10px'} || null">
        <div id="header-container" [hidden]="!isVisible">
            <app-header></app-header>

            <div id="breadcrumbs-container">
                <app-breadcrumbs></app-breadcrumbs>
            </div>
        </div>

        <div id="content">
            <router-outlet></router-outlet>
        </div>
    </div>
    <div [hidden]="!isVisible">
        <div id="mobile-footer">
            <app-mobile-menu></app-mobile-menu>
        </div>
    </div>
</div>

<p-toast
    id="error-messages-anchor"
    position="top-center"
    [key]="toasterPositions.TOP_CENTER"
    [preventOpenDuplicates]="true">
</p-toast>
<p-toast
    id="warning-success-messages-anchor"
    position="bottom-right"
    [key]="toasterPositions.BOTTOM_RIGHT"
    [preventOpenDuplicates]="true">
</p-toast>
